import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

// Admin callable functions
const adminEditBooking = httpsCallable(functions, 'adminEditBooking');
const adminSetAvailability = httpsCallable(functions, 'adminSetAvailability');
const adminSetException = httpsCallable(functions, 'adminSetException');
const adminRemoveException = httpsCallable(functions, 'adminRemoveException');
const adminUpdateSettings = httpsCallable(functions, 'adminUpdateSettings');
const adminGetBookings = httpsCallable(functions, 'adminGetBookings');
const adminGetAvailability = httpsCallable(functions, 'adminGetAvailability');
const adminGetSettings = httpsCallable(functions, 'adminGetSettings');

/**
 * Edit booking details
 */
export const editBooking = async (bookingId, updates) => {
  try {
    const result = await adminEditBooking({ bookingId, updates });
    return result.data;
  } catch (error) {
    console.error('Error editing booking:', error);
    throw new Error(error.message || 'Failed to update booking');
  }
};

/**
 * Set availability settings
 */
export const setAvailability = async (weeklySchedule, generalSettings) => {
  try {
    const result = await adminSetAvailability({ weeklySchedule, generalSettings });
    return result.data;
  } catch (error) {
    console.error('Error setting availability:', error);
    throw new Error(error.message || 'Failed to update availability settings');
  }
};

/**
 * Add blocked date exception
 */
export const addBlockedDate = async (date, type, startTime = null, endTime = null, reason = '') => {
  try {
    const result = await adminSetException({ date, type, startTime, endTime, reason });
    return result.data;
  } catch (error) {
    console.error('Error adding blocked date:', error);
    throw new Error(error.message || 'Failed to add blocked date');
  }
};

/**
 * Remove blocked date exception
 */
export const removeBlockedDate = async (blockedDateId) => {
  try {
    const result = await adminRemoveException({ blockedDateId });
    return result.data;
  } catch (error) {
    console.error('Error removing blocked date:', error);
    throw new Error(error.message || 'Failed to remove blocked date');
  }
};

/**
 * Update system settings
 */
export const updateSettings = async (settings) => {
  try {
    const result = await adminUpdateSettings({ settings });
    return result.data;
  } catch (error) {
    console.error('Error updating settings:', error);
    throw new Error(error.message || 'Failed to update settings');
  }
};

/**
 * Get all bookings with optional filters
 */
export const getBookings = async (filters = {}) => {
  try {
    const result = await adminGetBookings(filters);
    return result.data;
  } catch (error) {
    console.error('Error fetching bookings:', error);
    throw new Error(error.message || 'Failed to fetch bookings');
  }
};

/**
 * Get availability settings
 */
export const getAvailability = async () => {
  try {
    const result = await adminGetAvailability();
    return result.data;
  } catch (error) {
    console.error('Error fetching availability:', error);
    throw new Error(error.message || 'Failed to fetch availability settings');
  }
};

/**
 * Get system settings
 */
export const getSettings = async () => {
  try {
    const result = await adminGetSettings();
    return result.data;
  } catch (error) {
    console.error('Error fetching settings:', error);
    throw new Error(error.message || 'Failed to fetch settings');
  }
};

const adminReleaseHold = httpsCallable(functions, 'adminReleaseHold');

export const releaseHold = async (bookingId) => {
  try {
    const result = await adminReleaseHold({ bookingId });
    return result.data;
  } catch (error) {
    console.error('Error releasing hold:', error);
    throw new Error(error.message || 'Failed to release hold');
  }
};

